import { render, staticRenderFns } from "./PostCommentModeration.vue?vue&type=template&id=5c16b2f0&scoped=true"
import script from "./PostCommentModeration.vue?vue&type=script&lang=js"
export * from "./PostCommentModeration.vue?vue&type=script&lang=js"
import style0 from "./PostCommentModeration.vue?vue&type=style&index=0&id=5c16b2f0&prod&scoped=true&lang=css"
import style1 from "./PostCommentModeration.vue?vue&type=style&index=1&id=5c16b2f0&prod&lang=css"
import style2 from "./PostCommentModeration.vue?vue&type=style&index=2&id=5c16b2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16b2f0",
  null
  
)

export default component.exports